import { EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FC } from 'react';

interface IProps {
	onClick: () => void;
}

export const SeeTextButton: FC<IProps> = ({ onClick }) => (
	<Button {...{ onClick }}>
		<div className='flex items-center'>
			<EyeOutlined style={{ marginRight: '0.3rem' }} /> Corrigir Texto
		</div>
	</Button>
);
